// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"107cb791","283":"84336c89","305":"9ef22d15","313":"e28e6ffa","771":"7efbde22","901":"82da5c89"}[chunkId] + ".chunk.js";
};